import React from 'react';

import { TFunction } from 'i18next';

import {
  TPreCheckoutStep,
  usePreCheckout,
} from 'modules/checkout/presentation/contexts';
import { StepsProgressBar } from 'shared/presentation/components/atoms';
import { useLocale } from 'shared/presentation/contexts';

interface IPreCheckoutProgressProps {
  currentStep: TPreCheckoutStep;
}

function getStepStatus(
  steps: TPreCheckoutStep[],
  targetStep: TPreCheckoutStep,
  currentPreCheckoutStep: TPreCheckoutStep,
) {
  if (targetStep === currentPreCheckoutStep) return 'ACTIVE' as const;

  const targetStepIndex = steps.findIndex(step => targetStep === step);
  const currentStepIndex = steps.findIndex(
    step => currentPreCheckoutStep === step,
  );

  if (targetStepIndex < currentStepIndex) return 'COMPLETE' as const;

  return 'INACTIVE' as const;
}

const STEPS_TITLE: Record<
  TPreCheckoutStep,
  (t: TFunction<'checkout'>) => string
> = {
  BUDGET_SUMMARY: t => t('Summary'),
  CART_CHECKOUT: t => t('Payment'),
  FACIAL_RECOGNITION: t => t('Facial recognition'),
  FINISH_REGISTRATION: t => t('Complete registration'),
  LINK_CHECKOUT: t => t('Payment'),
  MULTIPLE_METHODS: t => t('Payment'),
};

const PreCheckoutProgress: React.FC<IPreCheckoutProgressProps> = ({
  currentStep,
}) => {
  const { t } = useLocale('checkout');
  const preCheckout = usePreCheckout();

  return (
    <StepsProgressBar
      height={8}
      steps={preCheckout.activeSteps.map(step => ({
        name: step,
        title: STEPS_TITLE[step](t),
        status: getStepStatus(preCheckout.activeSteps, step, currentStep),
      }))}
    />
  );
};

export default PreCheckoutProgress;
